function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 10c0-3.861 3.139-7 7-7s7 3.139 7 7c0 5.25-7 12.234-7 12 0 .234-7-6.75-7-12zm4.666 0a2.333 2.333 0 104.668 0c0-1.282-1.05-2.332-2.334-2.332S9.666 8.718 9.666 10z",
  fillRule: "evenodd",
  fill: "currentColor"
});

function SvgLocationCoordinate(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCoordinate);
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Im01IDEwYzAtMy44NjEyIDMuMTM4OC03IDctN3M3IDMuMTM4OCA3IDdjMCA1LjI1LTcgMTIuMjMzOC03IDEyIDAgLjIzMzgtNy02Ljc1LTctMTJ6bTQuNjY2MiAwYzAgMS4yODM4IDEuMDUgMi4zMzM4IDIuMzMzOCAyLjMzMzggMS4yOTUgMCAyLjMzMzgtMS4wNSAyLjMzMzgtMi4zMzM4IDAtMS4yODI0LTEuMDUtMi4zMzI0LTIuMzMzOC0yLjMzMjRzLTIuMzMzOCAxLjA1LTIuMzMzOCAyLjMzMjR6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L2c+PC9zdmc+Cg==";
export { ForwardRef as ReactComponent };